import { MatchBrowseItem, MatchSummaryV2 } from './types';

export const matchDetailHref = (match: MatchSummaryV2, returnTo: string): string => {
  const path = match.source === 'manual' ? `/matches/${match.manualId}` : `/matches/wyscout/${match.wyscoutMatchId}`;
  return `${path}?${new URLSearchParams({ returnTo })}`;
};

export const mapMatchSummary = (match: MatchSummaryV2, returnTo: string): MatchBrowseItem => ({
  ...match,
  href: matchDetailHref(match, returnTo),
  sourceLabel: match.source === 'manual' ? 'Manual' : 'Wyscout',
  teamsLabel: `${match.homeTeam.name} v ${match.awayTeam.name}`,
  scoreLabel: match.score ? `${match.score.home}-${match.score.away}` : null,
});
